const state = {
    consent: {},
    errors: {},
    filter: null,
    loading: false,
    participants: [],
    selectedParticipants: [],
    sortDirection: 'asc',
    sortField: 'star_id'
}

const getters = {
    //
}

const mutations = {
    setConsent (state, data) {
        return state.consent = data
    },
    setErrors (state, data) {
        return state.errors = data
    },
    setFilter(state, data) {
        return state.filter = data
    },
    setLoading(state, data) {
        return state.loading = data
    },
    setParticipants (state, data) {
        return state.participants = data
    },
    setSortDirection (state, data) {
        return state.sortDirection = data
    },
    setSortField (state, data) {
        return state.sortField = data
    },
    updateSelectedParticipants (state, data) {
        return state.selectedParticipants = data
    },
}

const actions = {
    assignTask (context, data) {
        context.commit("setLoading", true)
        let url = '/api/consents/'+state.consent.id+'/assignTask'

        axios.post(url, {'participant_ids': state.selectedParticipants})
            .then((response) => {
                context.dispatch('fetchParticipants')
                context.commit("setLoading", false)
            }).catch((e) => {
                context.commit("setLoading", false)
                context.commit("setErrors", e.response.data.message)
            })
    },
    cancelTask (context, task_id) {
        context.commit("setLoading", true)
        let url = '/api/tasks/'+task_id+'/cancel'

        axios.post(url)
            .then((response) => {
                context.dispatch('fetchParticipants')
                context.commit("setLoading", false)
            }).catch((e) => {
                context.commit("setLoading", false)
                context.commit("setErrors", e.response.data.message)
            })
    },
    async fetchParticipants (context) {
        context.commit("setLoading", true)
        context.commit("setParticipants", [])

        try {
            const res = await axios.get('/api/consents/'+state.consent.id+'/participants', {
                params: {
                    sortField: state.sortField,
                    sortDirection: state.sortDirection,
                    filter: state.filter
                }
            })
            context.commit("setParticipants", res.data.data)
            context.commit("updateSelectedParticipants", [])
        }
        catch (e) {
            console.log("Error: consents.js, fetchParticipants(), "+ e.message)   
        }
        finally {
            context.commit("setLoading", false)
        }
    },
    setConsent (context, data) {
        context.commit("setConsent", data)
    },
    setFilter (context, data) {
        context.commit("setFilter", data)
    },
    setSortDirection (context, data) {
        context.commit("setSortDirection", data)
    },
    setSortField (context, data) {
        context.commit("setSortField", data)
    },
    toggleAllSelectedParticipants(context, allChecked) {
        if (allChecked) {
            context.commit("updateSelectedParticipants", [])
        } else {
            let partIds = []
            state.participants.forEach(function (participant) {
                if (participant.current_task == null) {
                    partIds.push(participant.id)
                }
            })
            context.commit("updateSelectedParticipants", partIds)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}